import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  bgc: {
    marginTop: 12,
  },

  errorCaptured: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 5,
  },
  onlyShowConsistsBtnDiv: {
    margin: '15px 0',
  },
}))
